export const experienceData = [
  {
    Company: "Paycom",
    Position: "Software Developer",
    Duration: "Jan 2024 - Present",
    Technologies: [
      "PHP",
      "REST API",
      "Backend Development",
      "React",
      "Typescript",
      "Kubernetes",
      "Git",
      "Jira",
    ],
    Description: [
      "Created RESTful APIs with PHP microservices and ORM for third party vendor, securely retrieving data for over 1 million employees with a 95ms response time, using complex SQL queries for efficient data handling.",
      "Devised a user-friendly webpage for the legal team to seamlessly opt-out clients and employees from data sharing",
      "Migrated LRP jobs from a monolithic MVC architecture to a microservice , handling deployment with Kubernetes, Docker, GitLab, and Vault for secret management",
      "Optimized large-scale LRP data processing, extending data retrieval from 3 to 7 years and improving performance by batching, reducing total processing time by 40%",
      "Built a React dashboard for international clients to track payroll status, submit checks, and manage updates, streamlining payroll operations and improving data visibility.",
    ],
  },
  {
    Company: "Paycom",
    Position: "Software Developer Intern",
    Duration: "May 2023 - Aug 2023",
    Technologies: [
      "React",
      "Typescript",
      "NodeJS",
      "C#",
      "REST API",
      "Express",
      "XAML",
      "Git",
      "Jira",
    ],
    Description: [
      "Developed Visual Studio and VS code extension to perform Artifactory search with a data retrieval speed of 70%",
      "The project involved building query using AQL to fetch the searched data along with additional filters",
      "Typescript and React was used for creating the frontend in VS Code while C# and XAML for Visual Studio",
      "Performed Code reviews to ensure code quality and adherence to coding standards",
    ],
  },
  {
    Company: "University Of Texas at Dallas",
    Position: "Computer Science Grader",
    Duration: "Sept 2022 - May 2023",
    Technologies: ["C++", "Data Structures"],
    Description: [
      "Evaluated and assessed student assignments and exams, providing constructive feedback and assigning grades based on established criteria.",
      "Provided assistance with hands-on C++ lab assignments, ensuring that students understood and applied core programming concepts effectively.",
      "Offered guidance on coding techniques, debugging, and problem-solving to enhance their learning experience and facilitate their mastery of C++ programming skills.",
    ],
  },
  {
    Company: "University Of Texas at Dallas",
    Position: "Computer Science Outreach Assistant",
    Duration: "June 2022 - Aug 2022",
    Technologies: [
      "Python",
      "Java",
      "HTML",
      "CS",
      "JavaScript",
      "Data Structures",
    ],
    Description: [
      "Upgraded the coding skills of 20 young children by conducting weekly camps on programming with Java, Web page design and Python programming",
      "Provided coding exercises and challenging projects to work on and helped the students understand the concept of data structures and coding practices.",
    ],
  },
  {
    Company: "Tata Consultancy Services",
    Position: "Assistant System Engineer",
    Duration: "Nov 2020 - Nov 2021",
    Technologies: ["React", "Typescript", "REST API", "CI/CD", "HTML", "CSS"],
    Description: [
      "Collaborated as a team for a multinational science and technology company to convert their website from monolithic to microservice architecture",
      "Leveraged Micro-Frontend architecture and REST API integration with React and Typescript providing 97% time savings on inventory management.",
      "Automated CI/CD pipeline with Gitlab and collaborated with client to add reusable code to libraries, enhancing micro-frontend efficiency and performance.",
    ],
  },
];
